import React from "react";
import { Link } from "react-router-dom";

const LinkCell = (cellData) => {
  let id = cellData.key.id;

  return (
    <Link style={{color: "#007FBD"}}
          target="_blank"
          title="Открыть в новой вкладке"
          key={`/work/app/study/request/${id}`}
          to={`/work/app/study/request/${id}`}>
      {id}
    </Link>
  )
}

export default LinkCell;
